import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/ds/shadcn/components/ui/breadcrumb";
import { SidebarTrigger } from "@/ds/shadcn/components/ui/sidebar";
import { useSetHeaderBarToolsContainer } from "@/features/common/components/HeaderBarProvider";
import { useCallback, type FC } from "react";
import React from "react";
import { Link } from "react-router";

export interface HeaderBarProps {
	title: string;
	description: string;
	breadcrumb?: BreadcrumbItem[];
	showSideBarTrigger?: boolean;
}

export type BreadcrumbItem = {
	label: string;
	href?: string;
}

export const HeaderBar: FC<HeaderBarProps> = props => {
	const {
		title,
		description,
		breadcrumb = [],
		showSideBarTrigger = true
	} = props;

	const setContainer = useSetHeaderBarToolsContainer();
	const toolsRef = useCallback((node: HTMLDivElement | null) => {
		if (!setContainer) {
			return;
		}

		setContainer(node);
	}, [setContainer]);

	return (
		<>
			{
				(showSideBarTrigger || breadcrumb.length > 0) &&
				<div className="p-3 border-b flex gap-3 items-center">
					{showSideBarTrigger && <SidebarTrigger />}
					<Breadcrumb>
						<BreadcrumbList>
							{
								breadcrumb.map((x, i) => (
									<React.Fragment key={x.label}>
										<BreadcrumbItem>
											<BreadcrumbItemDisplay item={x} isLast={i === breadcrumb.length - 1} />
										</BreadcrumbItem>

										{i < breadcrumb.length - 1 && <BreadcrumbSeparator />}
									</React.Fragment>
								))
							}
						</BreadcrumbList>
					</Breadcrumb>
				</div>
			}
			<div className="@md:sticky bg-background z-10 top-0 @md:flex @md:justify-between @md:border-b">
				<div className="flex flex-col p-3 border-b @md:border-b-0 min-w-0">
					<h1 className="type-title truncate">{title}</h1>
					<div className="type-description truncate">{description}</div>
				</div>
				<div ref={toolsRef} className="flex flex-col gap-3 p-3 empty:hidden border-b @md:flex-row @md:items-center @md:border-b-0" />
			</div>
		</>
	);
};

interface RenderBreadcrumbItemProps {
	item: BreadcrumbItem;
	isLast: boolean;
}

const BreadcrumbItemDisplay = ({ item, isLast }: RenderBreadcrumbItemProps): React.JSX.Element => {
	if (isLast) {
		return (
			<BreadcrumbPage>
				{item.label}
			</BreadcrumbPage>
		);
	}

	if (item.href) {
		return (
			<BreadcrumbLink asChild>
				<Link to={item.href}>{item.label}</Link>
			</BreadcrumbLink>
		);
	}

	return (
		<span>
			{item.label}
		</span>
	);
};
